(function () {
  const bars = [];

  function isHeaderSectionHidden(section) {
    return (
      section.classList.contains('shopify-section-header-hidden') &&
      !section.classList.contains('menu-open')
    );
  }

  function getHeaderOffset() {
    let maxBottom = 0;

    document.querySelectorAll('.announcement-bar-section .utility-bar').forEach((el) => {
      const section = el.closest('.shopify-section');
      if (section && isHeaderSectionHidden(section)) return;

      const rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < 300) {
        maxBottom = Math.max(maxBottom, rect.bottom);
      }
    });

    const headerWrapper = document.querySelector('.section-header .header-wrapper');
    if (headerWrapper) {
      const section = headerWrapper.closest('.section-header');
      if (!section || !isHeaderSectionHidden(section)) {
        const rect = headerWrapper.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < 300) {
          maxBottom = Math.max(maxBottom, rect.bottom);
        }
      }
    }

    if (maxBottom > 0) return maxBottom;

    const headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    const announcement = document.querySelector('.announcement-bar-section .utility-bar');
    let fallback = Number.isFinite(headerHeight) && headerHeight > 0 ? headerHeight : 0;

    if (announcement) {
      const section = announcement.closest('.shopify-section');
      if (!section || !isHeaderSectionHidden(section)) {
        fallback += announcement.offsetHeight || 0;
      }
    }

    return fallback;
  }

  function getPinnedMetrics(bar, spacer) {
    const section = bar.closest('section');
    const isMobile = bar.classList.contains('product__sticky-top--mobile');
    let ref = bar.closest('.product__info-group');

    if (isMobile && section) {
      ref =
        section.querySelector('.product__info-group') ||
        section.querySelector('.product__info-container');
    }

    if (ref) {
      const rect = ref.getBoundingClientRect();
      return { left: rect.left, width: rect.width };
    }

    const anchor = spacer.getBoundingClientRect();
    return { left: anchor.left, width: anchor.width };
  }

  class ProductStickyBar {
    constructor(bar) {
      this.bar = bar;
      this.sentinel = bar.previousElementSibling;
      this.spacer = bar.nextElementSibling;

      if (!this.sentinel?.classList.contains('product__sticky-top-sentinel')) return;
      if (!this.spacer?.classList.contains('product__sticky-top-spacer')) return;

      this.ready = true;
    }

    reset() {
      this.bar.classList.remove('is-stuck', 'is-pinned');
      this.bar.style.position = '';
      this.bar.style.top = '';
      this.bar.style.left = '';
      this.bar.style.width = '';
      this.bar.style.zIndex = '';
      this.spacer.style.height = '0';
    }

    getBoundary() {
      if (this.bar.classList.contains('product__sticky-top--desktop')) {
        return this.bar.closest('.product__info-container');
      }

      return null;
    }

    update() {
      if (!this.ready) return;

      const offset = getHeaderOffset();
      const sentinelTop = this.sentinel.getBoundingClientRect().top;
      const boundary = this.getBoundary();

      if (sentinelTop >= offset) {
        this.reset();
        return;
      }

      if (boundary) {
        const boundaryRect = boundary.getBoundingClientRect();

        if (boundaryRect.bottom <= offset) {
          this.reset();
          return;
        }
      }

      this.bar.classList.add('is-stuck', 'is-pinned');

      const barHeight = this.bar.offsetHeight;
      this.spacer.style.height = `${barHeight}px`;

      const { left, width } = getPinnedMetrics(this.bar, this.spacer);

      let top = offset;

      if (boundary) {
        const maxTop = boundary.getBoundingClientRect().bottom - barHeight;
        if (maxTop < top) {
          top = maxTop;
        }
      }

      this.bar.style.position = 'fixed';
      this.bar.style.top = `${top}px`;
      this.bar.style.left = `${left}px`;
      this.bar.style.width = `${width}px`;
      this.bar.style.zIndex = '2';
    }
  }

  function init() {
    document.querySelectorAll('.product__sticky-top').forEach((bar) => {
      if (bar.dataset.stickyBarInit === 'true') return;

      const instance = new ProductStickyBar(bar);
      if (!instance.ready) return;

      bar.dataset.stickyBarInit = 'true';
      bars.push(instance);
    });
  }

  function updateAll() {
    document.documentElement.style.setProperty('--product-sticky-offset', `${getHeaderOffset()}px`);
    bars.forEach((bar) => bar.update());
  }

  let ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateAll();
      ticking = false;
    });
  }

  function onResize() {
    bars.forEach((bar) => bar.reset());
    updateAll();
  }

  init();
  updateAll();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (headerGroup && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(onResize).observe(headerGroup);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateAll);
  }

  document.addEventListener('shopify:section:load', () => {
    bars.length = 0;
    init();
    updateAll();
  });
})();
